import { AddMobileNumberView } from 'add_mobile_number/view'
import { t } from 'app/i18l'
import { buildAddPhoneNumberAction } from '@nextforce/api'
import { AddMobileNumberScreenProps } from 'home/stack/types'
import React, { useCallback } from 'react'
import { errorAlert } from 'shared/alerts'
import { usePerformUserProfileAction } from 'users/queries/perform_profile_action'

export function AddMobileNumberScreen({
  route,
  navigation,
}: AddMobileNumberScreenProps) {
  const { action, uri } = route.params
  const mutation = usePerformUserProfileAction(uri)

  const onSubmit = useCallback(
    async (phoneNumber: string) => {
      try {
        await mutation.mutateAsync(
          buildAddPhoneNumberAction(action, phoneNumber)
        )
        navigation.goBack()
      } catch (err: any) {
        errorAlert(err, t('addMobileNumberErrorTitle'))
      }
    },
    [mutation, action, navigation]
  )

  return (
    <AddMobileNumberView
      onSubmit={onSubmit}
      userName={action.params?.user_name}
    />
  )
}
